import { render, staticRenderFns } from "./Level2Heading.vue?vue&type=template&id=a7d2a6da&scoped=true&lang=pug&"
var script = {}
import style0 from "./Level2Heading.vue?vue&type=style&index=0&id=a7d2a6da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d2a6da",
  null
  
)

export default component.exports